import React from 'react';
import IDE from './components/Editos'

const App = () => {

  return (
    <div>
      <div>
        <IDE />
      </div>
    </div>
  );
};

export default App;
